import {
  CREATE_CATEGORY_FAILURE,
  CREATE_CATEGORY_REQUEST,
  GET_ALL_CATEGORY_REQUEST,
  GET_ALL_CATEGORY_SUCCESS,
  GET_ALL_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_FAILURE,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_FAILURE,
  DELETE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_BANNER_REQUEST,
  CREATE_CATEGORY_BANNER_FAILURE,
  UPDATE_CATEGORY_BANNER_REQUEST,
  UPDATE_CATEGORY_BANNER_FAILURE,
} from "./ActionType";

const initialState = {
  categories: [],
  loading: false,
  error: "",
};

export const adminCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CATEGORY_REQUEST:
      return { ...state, loading: true };

    case CREATE_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_CATEGORY_BANNER_REQUEST:
      return { ...state, loading: true };

    case CREATE_CATEGORY_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_CATEGORY_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_CATEGORY_SUCCESS:
      return { ...state, loading: false, error: "", categories: action.payload };

    case GET_ALL_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_CATEGORY_REQUEST:
      return { ...state, loading: true };

    case DELETE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        categories: state.categories?.response?.filter(cat => cat.id !== action.payload)  // Remove deleted category
      };

    case DELETE_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_CATEGORY_REQUEST:
      return { ...state, loading: true };

    case UPDATE_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_CATEGORY_BANNER_REQUEST:
      return { ...state, loading: true };

    case UPDATE_CATEGORY_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
